import { IIqMcInfoBadge } from './iq-mc-info-badge.interface';
import { DATIQ_DEFAULT_STRING } from '@dat/datiq-core/models';

export const emptyIqMcInfoBadge: IIqMcInfoBadge = {
    message: DATIQ_DEFAULT_STRING,
    showInfoIcon: true,
}